import * as React from 'react';
import { createUuid } from '~/utils/uuid';

const ShowOnRootContext = React.createContext<{
  content: any[];
  addContent: (id: string, newC: any) => void;
  removeContent: () => void;
}>({
  content: [],
  addContent: () => null,
  removeContent: () => null,
});

const ShowOnRootProvider = ({ children }) => {
  const [content, setContent] = React.useState<{ id: string; content: any }[]>([]);
  const addContent = React.useCallback(
    (id: string, newC: any) => {
      const find = content.find((c) => c.id === id);
      if (find) {
        setContent(content.map((c) => (c.id === id ? { id, content: newC } : c)));
      } else {
        setContent([...content, { id, content: newC }]);
      }
    },
    [content]
  );
  const removeContent = React.useCallback(() => {
    setContent([]);
  }, [content]);
  return (
    <ShowOnRootContext.Provider value={{ content, addContent, removeContent }}>
      {children}
      <ShowOnRootContext.Consumer>
        {(val) => {
          if (val) {
            return val.content.map((c) => c.content);
          }
          return null;
        }}
      </ShowOnRootContext.Consumer>
    </ShowOnRootContext.Provider>
  );
};
const ShowOnRootChild = ({ addContent, children, removeContent }) => {
  const randomId = React.useMemo(() => createUuid(), []);

  React.useEffect(() => {
    addContent(randomId, children);
    return () => {
      removeContent(randomId);
    };
  }, [children]);
  return null;
};
const ShowOnRoot = ({ children }) => {
  return (
    <ShowOnRootContext.Consumer>
      {({ addContent, removeContent }) => (
        <ShowOnRootChild addContent={addContent} removeContent={removeContent}>
          {children}
        </ShowOnRootChild>
      )}
    </ShowOnRootContext.Consumer>
  );
};

export { ShowOnRootProvider, ShowOnRoot };
